/* jshint browser:true */
/* eslint-disable require-jsdoc */
import 'regenerator-runtime/runtime';

import env from './env';
import SimpleHeader from './components/simple-header';
import Card from './components/card';
import FlexMenu from './components/flex-menu';
import SectionScroll from './components/section-scroll';
import FadeupScroll from './components/fade-up-scroll';
import Carousel from './components/carousel';
import CookieConsent from './components/cookie-consent';
import GoogleTranslate from './components/google-translate';
import SearchExpander from './components/search-expander';
import StickySidebar from './components/sticky-sidebar';

export default class Main {
  static initComponents() {
    // Initialize structural components.
    const simpleHeader = new SimpleHeader();
    const card = new Card();

    simpleHeader.init();
    card.init('.card');

    // Initialize navigation components.
    const flexMenu = new FlexMenu();
    const sectionScroll = new SectionScroll();
    const searchExpander = new SearchExpander();

    flexMenu.init('.flex-menu');

    const useSectionScroll = document.querySelector('.section-scroll');

    if (useSectionScroll) {
      const showSectionTitles = useSectionScroll.classList.contains(
        'section-scroll--show-title',
      );

      sectionScroll.init('.section-scroll', { showSectionTitles });
    }

    searchExpander.Configuration = {
      buttonSelector: '.r-button-search',
      searchSelector: '#searchExpanderTrigger',
      submitButtonSelector: '#searchExpanderSubmit',
      modalClass: '.search-modal',
      modalCancel: '.search-modal__close',
      targetUrl: env.searchPageUri,
    };

    searchExpander.init(
      searchExpander.Option.Focus |
        searchExpander.Option.Modal |
        searchExpander.Option.SubmitOnEnter,
    );

    // Initialize carousels.
    const carousel = new Carousel();

    carousel.init('.hero-carousel');

    // Initialize controls.
    const googleTranslate = new GoogleTranslate();

    googleTranslate.init('.google-translate');

    // Initialize effects.
    const fadeupScroll = new FadeupScroll();

    fadeupScroll.init('.fade-up-scroll');

    // Initialize dialogs.
    const cookieConsent = new CookieConsent();

    cookieConsent.init('.cookie-consent');

    StickySidebar.init('.sidebar');

    // Initialize content components.
    this.initContentComponents();
  }

  /**
   * Initializes non-structural components.
   */
  static async initContentComponents() {
    // TODO: Only initialize them if they're on the page.
    this.initAccordionTabs();
    this.initCountdownTimer();
    this.initMaps();
    this.initResponsiveTable();
    this.initGlossary();
  }

  /**
   * Initializes the accordion/tabs component.
   */
  static async initAccordionTabs() {
    const { default: AccordionTabs } = await import(
      './components/accordion-tabs'
    );
    const accordion = new AccordionTabs();

    accordion.init('.accordion');
  }

  /**
   * Initializes the countdown timer component.
   */
  static async initCountdownTimer() {
    const { default: CountdownTimer } = await import(
      './components/countdown-timer'
    );
    const countdownTimer = new CountdownTimer();

    countdownTimer.init('countdown-timer');
  }

  /**
   * Initializes map components.
   */
  static async initMaps() {
    const { Map, MarkerList } = await import(
      './components/map'
    );

    Map.init('.google-map');
    MarkerList.init('.google-map-marker-list', '.google-map-marker');
  }

  /**
   * Initializes the responsive table component.
   */
  static async initResponsiveTable() {
    const { default: ResponsiveTable } = await import(
      './components/responsive-table'
    );
    const responsiveTable = new ResponsiveTable();

    responsiveTable.init('.responsive-table');
  }

  /**
   * Initializes the responsive table component.
   */
  static async initGlossary() {
    const { default: Glossary } = await import(
      './components/glossary'
    );
    const glossary = new Glossary();

    glossary.init('.glossary');
  }

  /**
   * Fires when components are unloaded.
   */
  static destroyComponents() {
    // Remove Section Scroll button
    const ssButton = document.querySelector('.js-section-scroll__button');

    if (ssButton) {
      ssButton.remove();
    }

    // Remove dynamically-generated glossary styles
    const glossaryStyleSheets = document.querySelectorAll(
      '.js-glossary__style-sheet',
    );

    glossaryStyleSheets.forEach((x) => x.remove());
  }
}

if (typeof window.RavenPatternLibrary === 'undefined') {
  // We're not in the Raven Pattern Library, so run scripts on page load
  if ( document.readyforscripting ) {
    bootstrap();
  } else {
    document.addEventListener( 'readyforscripting', bootstrap );
  }
}

function bootstrap() {
  Main.initComponents();
}
